import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import Button from "../Button";
import "./ErrorState.scss";

const ErrorState = ({ message = "Something went wrong loading this page.", onRetry }) => (
  <div className="error-state">
    <FiAlertTriangle className="error-icon" size={40} />
    <div className="error-message">{message}</div>
    {onRetry ? (
      <Button type="primary" action={onRetry}>
        Retry
      </Button>
    ) : null}
  </div>
);

export default ErrorState;
